import React from "react";
import FieldInput from "./FieldInput";

const FieldEmail = (props) => {
  return <FieldInput type="email" {...props} />;
};

export default FieldEmail;
